import axiosConfig from "./axiosConfig";

interface HhDataTempProcessRequest {
  config?: any;
  // Provenance of this config, recorded in the file's attempt history:
  // "auto" (process_auto), "ai_fix" (an AI-proposed config), or "manual".
  source?: "auto" | "ai_fix" | "manual";
}

interface HhDataTempProcessResponse {
  operationKey: string;
  status: string;
}

const postHhDataTempProcess = async (
  authToken: string,
  fileGuid: string,
  request: HhDataTempProcessRequest
): Promise<HhDataTempProcessResponse> => {
  const { data } = await axiosConfig.post(
    `/hh_data/temp/${fileGuid}/process`,
    request,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postHhDataTempProcess;
